/**
 * Agency FAQ / Updates — filtering, sorting, expand/collapse.
 * Refactored to support decoupled sections (Filter bar separate from List).
 * Theme editor safe: init per section, re-init on shopify:section:load.
 */
(function () {
  'use strict';

  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function buildUniqueOptions(cards, attr) {
    var set = {};
    cards.forEach(function (card) {
      var val = (card.getAttribute('data-' + attr) || '').trim();
      if (val) set[val] = true;
    });
    return Object.keys(set).sort();
  }

  function parseDate(str) {
    if (!str) return 0;
    var d = new Date(str.trim());
    return isNaN(d.getTime()) ? 0 : d.getTime();
  }

  // LOGIC FOR FILTER SECTION CONTROLLING GLOBAL LIST
  function initFilterSection(sectionEl) {
    if (sectionEl.dataset.initialized === 'true') return;
    sectionEl.dataset.initialized = 'true';

    var sectionId = sectionEl.getAttribute('data-section-id');
    var defaultSort = (sectionEl.getAttribute('data-default-sort') || 'newest').toLowerCase();
    
    // TARGET GLOBAL LIST
    var listEl = document.getElementById('FaqUpdatesList-Global');
    var emptyEl = document.getElementById('FaqUpdatesEmpty-Global');
    
    // If no global list, try looking for the old local list (backward compatibility)
    if (!listEl) {
       listEl = document.getElementById('FaqUpdatesList-' + sectionId);
       emptyEl = document.getElementById('FaqUpdatesEmpty-' + sectionId);
    }

    if (!listEl) return;

    var cards = [].slice.call(listEl.querySelectorAll('.agency-faq-updates__card'));
    var releaseTypeSelect = document.getElementById('FaqFilterReleaseType-' + sectionId);
    var productAreaSelect = document.getElementById('FaqFilterProductArea-' + sectionId);
    var integrationSelect = document.getElementById('FaqFilterIntegration-' + sectionId);
    var dateSelect = document.getElementById('FaqFilterDate-' + sectionId);

    function populateFilterOptions() {
      var releaseTypes = buildUniqueOptions(cards, 'release-type');
      var productAreas = buildUniqueOptions(cards, 'product-area');
      var integrations = buildUniqueOptions(cards, 'integration');

      function fillSelect(select, options, firstLabel) {
        if (!select) return;
        var current = select.value;
        select.innerHTML = '';
        var first = document.createElement('option');
        first.value = '';
        first.textContent = firstLabel || 'All';
        select.appendChild(first);
        options.forEach(function (opt) {
          var o = document.createElement('option');
          o.value = opt;
          o.textContent = opt.replace(/-/g, ' ');
          select.appendChild(o);
        });
        if (options.indexOf(current) !== -1) select.value = current;
      }

      fillSelect(releaseTypeSelect, releaseTypes, 'Release Type');
      fillSelect(productAreaSelect, productAreas, 'Product Area');
      fillSelect(integrationSelect, integrations, 'Integration');
    }

    function getFilters() {
      return {
        releaseType: releaseTypeSelect ? (releaseTypeSelect.value || '').trim() : '',
        productArea: productAreaSelect ? (productAreaSelect.value || '').trim() : '',
        integration: integrationSelect ? (integrationSelect.value || '').trim() : '',
        dateOrder: dateSelect ? (dateSelect.value || defaultSort).toLowerCase() : defaultSort
      };
    }

    function cardMatches(card, filters) {
      if (filters.releaseType) {
        var rt = (card.getAttribute('data-release-type') || '').trim();
        if (rt !== filters.releaseType) return false;
      }
      if (filters.productArea) {
        var pa = (card.getAttribute('data-product-area') || '').trim();
        if (pa !== filters.productArea) return false;
      }
      if (filters.integration) {
        var ig = (card.getAttribute('data-integration') || '').trim();
        if (ig !== filters.integration) return false;
      }
      return true;
    }

    function applyFilterAndSort() {
      var filters = getFilters();
      var visible = cards.filter(function (card) { return cardMatches(card, filters); });

      visible.sort(function (a, b) {
        var tA = parseDate(a.getAttribute('data-date'));
        var tB = parseDate(b.getAttribute('data-date'));
        if (filters.dateOrder === 'oldest') return tA - tB;
        return tB - tA;
      });

      cards.forEach(function (card) {
        card.style.display = 'none';
        card.removeAttribute('data-sort-order');
      });
      visible.forEach(function (card, index) {
        card.style.display = '';
        card.setAttribute('data-sort-order', index);
      });

      if (listEl.parentNode) {
        visible.forEach(function (card) {
          listEl.appendChild(card);
        });
      }

      if (emptyEl) {
        emptyEl.hidden = visible.length > 0;
      }
    }

    populateFilterOptions();
    applyFilterAndSort();

    if (releaseTypeSelect) releaseTypeSelect.addEventListener('change', applyFilterAndSort);
    if (productAreaSelect) productAreaSelect.addEventListener('change', applyFilterAndSort);
    if (integrationSelect) integrationSelect.addEventListener('change', applyFilterAndSort);
    if (dateSelect) dateSelect.addEventListener('change', applyFilterAndSort);
  }

  // LOGIC FOR "SEE MORE" (Runs on any agency-faq-updates section)
  function initSeeMore(sectionEl) {
     sectionEl.querySelectorAll('[data-see-more]').forEach(function (btn) {
        if (btn._faqSeeMoreBound) return;
        btn._faqSeeMoreBound = true;
        var id = btn.getAttribute('aria-controls');
        var panel = id ? document.getElementById(id) : null;
        if (!panel) return;

        btn.addEventListener('click', function () {
          var expanded = btn.getAttribute('aria-expanded') === 'true';
          if (expanded) {
            btn.setAttribute('aria-expanded', 'false');
            btn.textContent = 'See more';
            panel.hidden = true;
            if (panel.style) panel.style.height = '';
          } else {
            btn.setAttribute('aria-expanded', 'true');
            btn.textContent = 'See less';
            panel.hidden = false;
            if (!REDUCED_MOTION && panel.offsetHeight) {
              panel.style.height = '0px';
              panel.style.overflow = 'hidden';
              panel.style.transition = 'height 0.3s ease';
              requestAnimationFrame(function () {
                panel.style.height = panel.scrollHeight + 'px';
              });
              var onTransitionEnd = function () {
                panel.removeEventListener('transitionend', onTransitionEnd);
                panel.style.height = '';
                panel.style.overflow = '';
                panel.style.transition = '';
              };
              panel.addEventListener('transitionend', onTransitionEnd);
              setTimeout(onTransitionEnd, 350);
            }
          }
        });
      });
  }

  function init() {
    // Init Filters
    document.querySelectorAll('.agency-faq-updates[data-is-filter-section="true"]').forEach(function(el) {
        if(el.dataset.initialized !== 'true') initFilterSection(el);
    });
    // Init See More (can run on any of these sections)
    document.querySelectorAll('.agency-faq-updates').forEach(function(el) {
        initSeeMore(el);
    });
    
    // Historical/Fallback support for old monolithic section
    document.querySelectorAll('.agency-faq-updates[data-section-id][data-initialized="false"]').forEach(function(el) {
       // identifying old section by checking if it has internal list container
       if(el.querySelector('.agency-faq-updates__list')) {
           initFilterSection(el); 
       }
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function (e) {
    var sectionEl = e.target && e.target.classList && e.target.classList.contains('agency-faq-updates')
      ? e.target
      : (e.target && e.target.querySelector ? e.target.querySelector('.agency-faq-updates') : null);
    if (sectionEl) {
      sectionEl.dataset.initialized = 'false';
      initSeeMore(sectionEl);
      if(sectionEl.dataset.isFilterSection === 'true' || sectionEl.querySelector('.agency-faq-updates__list')) {
          initFilterSection(sectionEl);
      }
    }
  });
})();
